import {Dialog, Grid, AppBar, Typography, Toolbar, IconButton, FormControl} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {useTranslation} from "react-i18next";
import React, {Fragment} from 'react';
import {observer} from 'mobx-react';
import {useGlobalStorage} from './mobx/GlobalStorage.js';

export const blAreaList = [
	{id: 1, desc: 'bl.inland', abbr: 'Si'},		// Sisämaa
	{id: 2, desc: 'bl.coast', abbr: 'Ra'},		// Rannikko
	{id: 3, desc: 'bl.bothnian', abbr: 'Pe'},	// Perämeri
	{id: 4, desc: 'bl.north', abbr: 'Po'}		// Pohjoinen
];

const BlMonths = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const n = gStorage.conn.bl_notification;

	if (!(n.reason_mask & 0x04) || !n.months.length)
		return null;

	return (
		<Fragment>
			<div>&nbsp;</div>
			<div style={{align: 'center', fontWeight: 'bold'}}>
				{t('bl.months')}
			</div>
			<div>{
				n.months.map((m, ind) => {
					let str = m;

					if (ind < n.months.length - 1)
						str += ', ';

					return str;
				})
			}</div>
		</Fragment>
	);
});

const BlRegions = observer(() => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const n = gStorage.conn.bl_notification;

	if (!(n.reason_mask & 0x08) || !n.regions.length)
		return null;

	return (
		<Fragment>
			<div>&nbsp;</div>
			<div style={{align: 'center', fontWeight: 'bold'}}>
				{t('bl.regions')}
			</div>
			<div>{
				n.regions.map((r, ind) => {
					let str = r;

					if (ind < n.regions.length - 1)
						str += ', ';

					return str;
				})
			}</div>
		</Fragment>
	);
});

const BlInfo = observer(() => {
	const gStorage = useGlobalStorage();
	const n = gStorage.conn.bl_notification;

	if (!n.info.length)
		return null;

	return (
		<Fragment>
			<div>&nbsp;</div>
			<div style={{align: 'center', fontStyle: 'italic'}}>
				{n.info}
			</div>
		</Fragment>
	);
});

const BlDialog = observer((props) => {
	const {isOpen, handleClose} = props;
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const n = gStorage.conn.bl_notification;

	if (!n)
		return null;

	return (
        	<Dialog onClose={() => handleClose(false)} aria-labelledby="bl-dialog" open={isOpen ? true : false} PaperProps={{sx: {margin: 0, padding: 0}}} >
			<Grid container direction="row" justifyContent="center" alignItems="center" spacing={0} style={{width:316}}>
				<AppBar position="sticky">
					<Toolbar variant="dense">
						<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{t('bl.reporting_needed')}</Typography>
						<IconButton edge="start" color="inherit" onClick={() => handleClose(false)} aria-label="close">
							<CloseIcon />
						</IconButton>
					</Toolbar>
				</AppBar>

				<Grid size={{xs: 12}} align={'center'} style={{width:300}}>
					<FormControl variant="outlined" size="small" style={{width:300}} >
						<div>&nbsp;</div>
						<div>{n.spec}</div>
						<Typography variant='h6' align='center'>
							{n.reason}
						</Typography>
						<BlMonths/>
						<BlRegions/>
						<BlInfo/>
						<div>&nbsp;</div>
					</FormControl>
				</Grid>
			</Grid>
		</Dialog>
	);
});

export default BlDialog;
